import "@nextgisweb/jsrealm/with-chunks!@nextgisweb/jsrealm/locale/ru"
ngwConfig.plurals = [3, n => Number((n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2))];
export { default as antd } from "/opt/ngw/node_modules/antd/es/locale/ru_RU.js";
import dayjs from "@nextgisweb/gui/dayjs";
import "/opt/ngw/node_modules/dayjs/locale/ru.js";
dayjs.locale('ru');
import "/opt/ngw/package/nextgisweb/nextgisweb/core/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/pyramid/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/gui/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/auth/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/resource/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/resmeta/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/social/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/spatial_ref_sys/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/layer/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/layer_preview/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/feature_layer/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/feature_description/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/feature_attachment/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/render/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/svg_marker_library/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/webmap/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/vector_layer/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/lookup_table/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/postgis/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/tablenogeom/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/raster_layer/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/raster_mosaic/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/raster_style/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/wfsserver/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/wfsclient/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/wmsclient/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/wmsserver/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/ogcfserver/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/tmsclient/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/file_upload/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/audit/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/tileset/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/basemap/locale/ru.po";
import "/opt/ngw/package/nextgisweb/nextgisweb/sld/locale/ru.po";
import "/opt/ngw/package/nextgisweb_file_bucket/nextgisweb_file_bucket/locale/ru.po";
import "/opt/ngw/package/nextgisweb_mapserver/nextgisweb_mapserver/locale/ru.po";
import "/opt/ngw/package/nextgisweb_qgis/nextgisweb_qgis/locale/ru.po";